import type { ListWorkflowTemplatesResponseJSON } from "@performyard/service-contracts";

import request from "./internal-api/internal-base-request";

export type WorkflowTemplateSortBy = "name" | "last_update" | "todoCount";

export interface ListWorkflowTemplatesParams {
	sortBy?: WorkflowTemplateSortBy;
	sortOrder?: "asc" | "desc";
	limit?: number;
	skip?: number;
}

export const getWorkflowTemplates = async (
	params: ListWorkflowTemplatesParams = {}
): Promise<ListWorkflowTemplatesResponseJSON> => {
	const searchParams = new URLSearchParams();
	if (params.sortBy) searchParams.set("sortBy", params.sortBy);
	if (params.sortOrder) searchParams.set("sortOrder", params.sortOrder);
	if (params.limit !== undefined) searchParams.set("limit", String(params.limit));
	if (params.skip !== undefined) searchParams.set("skip", String(params.skip));

	const query = searchParams.toString();
	const [response] = await request<ListWorkflowTemplatesResponseJSON>(
		`/v1/workflow-templates${query ? `?${query}` : ""}`,
		{ method: "GET" }
	);
	return response;
};
